import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'night' | 'surface' | 'navy' | 'warm' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  background = 'night'
}: SectionProps) {
  const backgrounds = {
    night: 'bg-brand-night',
    surface: 'bg-brand-surface',
    navy: 'bg-[#1A1208]',
    warm: 'bg-[#1F1509]',
    white: 'bg-brand-surface' // no pure white — keep dark
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-157">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">{children}</div>
    </section>;
}